// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3uvv5","image":"Header_image__waP50","name":"Header_name__2VUIO","info":"Header_info___orQ4","infoRow":"Header_infoRow__2LDa5"};